import Faqs from "./views/faqs";
import Blogs from "./views/blogs";
import Career from "./views/career";
import AboutUs from "./views/aboutus";
import Network from "./views/network";
import Products from "./views/products";
import ContactUs from "./views/contactus";
import Dashboard from "./views/dashboard";
import MainLayout from "./layout/HomeLayout";
import BlogDetails from "./views/blogdetails";
import PrivacyPolicy from "./views/privacypolicy";
import TermConditions from "./views/termconditions";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TravelAssistance from "./views/travelassistance";
import AutomotiveAssistance from "./views/automotiveassistance";
import GadgetProtection from "./views/gadgetprotection";
import HomeAppliance from "./views/homeappliance";
import HomeAssistance from "./views/homeassistance";
import IncomeProtect from "./views/incomeprotect";
import TravelMedical from "./views/travelmedical";
import CyberSecurity from "./views/cybersecurity";
import ScrollToTop from "./components/ScrollToTop";
import GlobalCookies from "./components/GlobalCookies";

const theme = createTheme();

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        {/* Scroll To Top */}
        <ScrollToTop />

        {/* 🔹 Cookie Consent Banner */}
        <GlobalCookies />

        <Routes>
          <Route path="/">
            <Route
              path="/"
              element={
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              }
            />
            <Route
              path="/about-us"
              element={
                <MainLayout>
                  <AboutUs />
                </MainLayout>
              }
            />
            <Route
              path="/blogs"
              element={
                <MainLayout>
                  <Blogs />
                </MainLayout>
              }
            />
            <Route
              path="/career"
              element={
                <MainLayout>
                  <Career />
                </MainLayout>
              }
            />
            <Route
              path="/become-partner"
              element={
                <MainLayout>
                  <Network />
                </MainLayout>
              }
            />
            <Route
              path="/products"
              element={
                <MainLayout>
                  <Products />
                </MainLayout>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <MainLayout>
                  <PrivacyPolicy />
                </MainLayout>
              }
            />
            <Route
              path="/terms-&-conditions"
              element={
                <MainLayout>
                  <TermConditions />
                </MainLayout>
              }
            />
            <Route
              path="/faqs"
              element={
                <MainLayout>
                  <Faqs />
                </MainLayout>
              }
            />
            <Route
              path="/contact"
              element={
                <MainLayout>
                  <ContactUs />
                </MainLayout>
              }
            />
            <Route
              path="/blogdetails/:blogId"
              element={
                <MainLayout>
                  <BlogDetails />
                </MainLayout>
              }
            />
            {/* <Route path="/blog/:blogId" element={<BlogDetails />} /> */}
            <Route
              path="/travel-assistance"
              element={
                <MainLayout>
                  <TravelAssistance />
                </MainLayout>
              }
            />
            <Route
              path="/automotive-assistance"
              element={
                <MainLayout>
                  <AutomotiveAssistance />
                </MainLayout>
              }
            />
            <Route
              path="/gadget-protection"
              element={
                <MainLayout>
                  <GadgetProtection />
                </MainLayout>
              }
            />
            <Route
              path="/home-appliance"
              element={
                <MainLayout>
                  <HomeAppliance />
                </MainLayout>
              }
            />

            <Route
              path="/home-assistance"
              element={
                <MainLayout>
                  <HomeAssistance />
                </MainLayout>
              }
            />

            <Route
              path="/income-protect"
              element={
                <MainLayout>
                  <IncomeProtect />
                </MainLayout>
              }
            />

            <Route
              path="/travel-and-medical"
              element={
                <MainLayout>
                  <TravelMedical />
                </MainLayout>
              }
            />

            <Route
              path="/cyber-security"
              element={
                <MainLayout>
                  <CyberSecurity />
                </MainLayout>
              }
            />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
